export default __webpack_public_path__ + "static/media/bnb-bbank.4958abaa.png";